var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cross-domain-auth"},_vm._l((_vm.sitesToAuthenticate),function(site){return _c('a-cross-domain-iframe',{key:site,attrs:{"site":site,"settings":_vm.cookieSettings}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }